import { entityRegistry } from "./utilts/columnUtils"

export const createEntities = () => {
    entityRegistry.register('client', () => import('./clientFields'));
    entityRegistry.register('event', () => import('./eventFields'));
    entityRegistry.register('expense', () => import('./expenseFields'));
    entityRegistry.register('group', () => import('./groupFields'));
    entityRegistry.register('hour', () => import('./hoursFields'));
    entityRegistry.register('location', () => import('./locationFields'));
    entityRegistry.register('member', () => import('./memberFields'))
    entityRegistry.register('mqual', () => import('./memberQualificationsFields'));
    entityRegistry.register('position', () => import('./positionFields'));
    entityRegistry.register('qualification', () => import('./qualificationFields'));
    entityRegistry.register('qualRequest', () => import('./qualRequestFields'));
    entityRegistry.register('roster', () => import('./rosterFields'));
    entityRegistry.register('removedRoster', () => import('./removedRosterFields'));
    entityRegistry.register('shift', () => import('./shiftFields'));
    entityRegistry.register('template', () => import('./eventTemplateFields'));
    entityRegistry.register('accreditation', () => import('./accreditationFields'));
    entityRegistry.register('meeting', () => import('./meetingFields'));
    entityRegistry.register('announcement', () => import('./announcementFields'));
    entityRegistry.register('kiosk', () => import('./kioskFields'));
    entityRegistry.register('leave', () => import('./memberLeaveFields'));
    entityRegistry.register('equipment', () => import('./equipmentFields'));
    entityRegistry.register('visa', () => import('./visaFields'));
    entityRegistry.register('item', () => import('./itemFields'));
    entityRegistry.register('inventory', () => import('./inventoryFields'));
    entityRegistry.register('supplier', () => import('./supplierFields'));
    entityRegistry.register('availability', () => import('./availabilityFields'));
    entityRegistry.register('meetingAttendee', () => import('./meetingAttendeeFields'));
    entityRegistry.register('accreditationOverrides', () => import('./accreditationOverrideFields'));
    entityRegistry.register('user', () => import('./userFields'));
}